/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerProjection } from './PartnerProjection';
import {
    PartnerProjectionFromJSON,
    PartnerProjectionFromJSONTyped,
    PartnerProjectionToJSON,
    PartnerProjectionToJSONTyped,
} from './PartnerProjection';
import type { UserProjection } from './UserProjection';
import {
    UserProjectionFromJSON,
    UserProjectionFromJSONTyped,
    UserProjectionToJSON,
    UserProjectionToJSONTyped,
} from './UserProjection';

/**
 * 
 * @export
 * @interface Call
 */
export interface Call {
    /**
     * 
     * @type {number}
     * @memberof Call
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    callDate: string;
    /**
     * 
     * @type {string}
     * @memberof Call
     */
    comment: string;
    /**
     * 
     * @type {boolean}
     * @memberof Call
     */
    doNotDisturb: boolean;
    /**
     * 
     * @type {UserProjection}
     * @memberof Call
     */
    userId: UserProjection;
    /**
     * 
     * @type {number}
     * @memberof Call
     */
    sessionId?: number | null;
    /**
     * 
     * @type {PartnerProjection}
     * @memberof Call
     */
    partnerId: PartnerProjection;
}

/**
 * Check if a given object implements the Call interface.
 */
export function instanceOfCall(value: object): value is Call {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('callDate' in value) || value['callDate'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('doNotDisturb' in value) || value['doNotDisturb'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    return true;
}

export function CallFromJSON(json: any): Call {
    return CallFromJSONTyped(json, false);
}

export function CallFromJSONTyped(json: any, ignoreDiscriminator: boolean): Call {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'callDate': json['call_date'],
        'comment': json['comment'],
        'doNotDisturb': json['do_not_disturb'],
        'userId': UserProjectionFromJSON(json['user_id']),
        'sessionId': json['session_id'] == null ? undefined : json['session_id'],
        'partnerId': PartnerProjectionFromJSON(json['partner_id']),
    };
}

export function CallToJSON(json: any): Call {
    return CallToJSONTyped(json, false);
}

export function CallToJSONTyped(value?: Call | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'call_date': value['callDate'],
        'comment': value['comment'],
        'do_not_disturb': value['doNotDisturb'],
        'user_id': UserProjectionToJSON(value['userId']),
        'session_id': value['sessionId'],
        'partner_id': PartnerProjectionToJSON(value['partnerId']),
    };
}

